import { MDBCol, MDBContainer, MDBRow, MDBTypography } from "mdb-react-ui-kit";
import styled from "styled-components";
import { useAuth } from "../../../components/Auth";
import { MDBSwitch } from "mdb-react-ui-kit";

export const StyledSwitchWrapper = styled.div`
  label.form-check-label {
    color: #212529 !important;
    opacity: 1 !important;
  }

  .form-check-input:disabled ~ .form-check-label:hover {
    color: #212529 !important;
  }
`;

const DisabledStyledSwitch = (props) => (
    <StyledSwitchWrapper>
        <MDBSwitch {...props} disabled />
    </StyledSwitchWrapper>
);

export const SwitchGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || "0.7rem"};
`;

const FeatureSection = ({
    title,
    visible = true,
    messageWhenHidden = null,
    className = "mb-3",
    children,
}) => {
    return (
        <MDBRow className={className}>
            <hr className="hr" />
            <MDBTypography variant="h6" className="mb-3 fw-bold">
                {title}
            </MDBTypography>
            {visible
                ? children
                : (
                    <MDBTypography className="text-muted fst-italic">
                        {messageWhenHidden}
                    </MDBTypography>
                )}
        </MDBRow>
    );
};

const SignalsTab = () => {
    const { profile, cactusToolConfigExists } = useAuth();

    return (
        <MDBContainer className="m-5">
            <MDBTypography variant="h5" className="mb-4 fw-bold">
                Ambient Screening Profile
            </MDBTypography>
            <MDBRow className="mb-3">
                <MDBCol>
                    <MDBTypography variant="h6" className="mb-3 fw-bold">
                        PubPeer
                    </MDBTypography>
                    <SwitchGroup className="mb-2">
                        <DisabledStyledSwitch
                            checked={!!profile["tool.pubPeerHits"]}
                            label="PubPeer hits"
                        />
                    </SwitchGroup>
                </MDBCol>
                <MDBCol>
                    <MDBTypography variant="h6" className="mb-3 fw-bold">
                        ClearSkies Papermill Alarm: Public
                    </MDBTypography>
                    <SwitchGroup className="mb-2">
                        <DisabledStyledSwitch
                            label="Papermill similarity"
                            checked={!!profile["tool.papermillSimilarity"]}
                        />
                    </SwitchGroup>
                </MDBCol>
            </MDBRow>

            <FeatureSection
                title="Cactus Integrity Checks"
                messageWhenHidden="Cactus Integrity Checks are not available for this publisher"
                visible={cactusToolConfigExists}
            >
                <MDBCol>
                    <SwitchGroup>
                        <DisabledStyledSwitch
                            label="Author affiliation relevance"
                            checked={!!profile["tool.cactusTool.authorAffiliationRelevance"]}
                        />
                        <DisabledStyledSwitch
                            label="Author geographical distribution"
                            checked={!!profile["tool.cactusTool.authorGeographicalDistribution"]}
                        />
                        <DisabledStyledSwitch
                            label="Authors with previous retractions"
                            checked={!!profile["tool.cactusTool.authorWithRetraction"]}
                        />
                        <DisabledStyledSwitch
                            label="Age of reference"
                            checked={!!profile["tool.cactusTool.ageOfReference"]}
                        />
                    </SwitchGroup>
                </MDBCol>
                <MDBCol>
                    <SwitchGroup>
                        <DisabledStyledSwitch
                            label="Reference citation"
                            checked={!!profile["tool.cactusTool.referenceCitation"]}
                        />
                        <DisabledStyledSwitch
                            label="Citation cartel"
                            checked={!!profile["tool.cactusTool.citationCartel"]}
                        />
                        <DisabledStyledSwitch
                            label="Self citation"
                            checked={!!profile["tool.cactusTool.selfCitation"]}
                        />
                        <DisabledStyledSwitch
                            label="Unrelated references"
                            checked={!!profile["tool.cactusTool.unrelatedReferences"]}
                        />
                    </SwitchGroup>
                </MDBCol>
            </FeatureSection>

            <MDBRow className="mb-3">
                <hr className="hr" />
                <MDBCol>
                    <MDBTypography variant="h6" className="mb-3 fw-bold">
                        Reference analysis
                    </MDBTypography>
                    <SwitchGroup>
                        <DisabledStyledSwitch
                            label="Retraction Watch"
                            checked={!!profile["tool.retractionWatch"]}
                        />
                        <DisabledStyledSwitch
                            label="DOI analysis"
                            checked={!!profile["tool.doiAnalysis"]}
                        />
                        <DisabledStyledSwitch
                            label="Crossref checks"
                            checked={!!profile["tool.crossrefChecks"]}
                        />
                    </SwitchGroup>
                </MDBCol>
                <MDBCol>
                    <MDBTypography variant="h6" className="mb-3 fw-bold">
                        Text analysis
                    </MDBTypography>
                    <SwitchGroup>
                        <DisabledStyledSwitch
                            label="Tortured phrases"
                            checked={!!profile["tool.torturedPhrases"]}
                        />
                        <DisabledStyledSwitch
                            label="Suspect phrases"
                            checked={!!profile["tool.suspectPhrases"]}
                        />
                        <DisabledStyledSwitch
                            label="GenAI response"
                            checked={!!profile["tool.genAIResponse"]}
                        />
                        <DisabledStyledSwitch
                            label="Unnatural text"
                            checked={!!profile["tool.unnaturalText"]}
                        />
                        <DisabledStyledSwitch
                            // label="Geppetto"
                            label="Nonsensical text"
                            checked={!!profile["tool.geppetto"]}
                        />
                    </SwitchGroup>
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3">
                <hr className="hr" />
                <MDBCol>
                    <MDBTypography variant="h6" className="mb-3 fw-bold">
                        Metadata analysis
                    </MDBTypography>
                    <DisabledStyledSwitch
                        checked={!!profile["tool.wordFileMetadata"]}
                        label="Word file metadata"
                    />
                </MDBCol>
                <MDBCol>
                    <MDBTypography variant="h6" className="mb-3 fw-bold">
                        Duplicate submissions
                    </MDBTypography>
                    <SwitchGroup>
                        <DisabledStyledSwitch
                            checked={!!profile["tool.duplicateSubmissions.metadataScreening"]}
                            label="Metadata screening"
                        />
                        <DisabledStyledSwitch
                            checked={!!profile["tool.duplicateSubmissions.fullTextScreening"]}
                            label="Full-text screening"
                        />
                    </SwitchGroup>
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3">
                <hr className="hr" />
                <MDBCol>
                    <MDBTypography variant="h6" className="mb-3 fw-bold">
                        SignalCheck
                    </MDBTypography>
                    <SwitchGroup>
                        <DisabledStyledSwitch
                            label="Fake affiliation names"
                            checked={!!profile["tool.watchlist.fakeAffiliationNames"]}
                        />
                        <DisabledStyledSwitch
                            label="Fake names or e-mail addresses"
                            checked={!!profile["tool.watchlist.fakeNamesOrEmailAddresses"]}
                        />
                        <DisabledStyledSwitch
                            label="Fake e-mail domains"
                            checked={!!profile["tool.watchlist.fakeEmailDomains"]}
                        />
                        <DisabledStyledSwitch
                            label="Disposable e-mail domains"
                            checked={!!profile["tool.watchlist.disposableEmailDomains"]}
                        />
                    </SwitchGroup>
                </MDBCol>
                <MDBCol>
                    <SwitchGroup style={{ marginTop: '33px' }}>
                        <DisabledStyledSwitch
                            label="Suspect articles"
                            checked={!!profile["tool.watchlist.suspectArticles"]}
                        />
                        <DisabledStyledSwitch
                            label="Manuscripts offered for sale"
                            checked={!!profile["tool.watchlist.manuscriptsOfferedForSale"]}
                        />
                        <DisabledStyledSwitch
                            label="Metadata suspects"
                            checked={!!profile["tool.watchlist.metadataSuspects"]}
                        />
                    </SwitchGroup>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
};

export default SignalsTab;
